import actions from './actions'

const initialState = {
  groups: [],
  schools: [],
  loading: false,
  ready: false,
}

export default function groupsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
